import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { TStyles } from '~/src/features/movix-new/ContentCard';

export const Wrapper = styled.div<{ isRightSide?: boolean, styles?: TStyles }>`
    flex-direction: column;
    margin-bottom: 24px;
    width: 100%;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 40px;
    }

    ${({ styles }) => styles}
`;

export const Header = styled.div`
    ${FONTS.H3};
    margin-bottom: 16px;
    white-space: pre-wrap;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const BlockWrapper = styled.div`
    flex-direction: column;
    width: 100%;

    & > div {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const InfoBlock = styled.div<{ toggled?: boolean, hasTitle?: boolean, styles?: TStyles }>`
    padding: ${({ hasTitle }) => hasTitle ? '12px 12px 16px 24px' : '24px'};
    background-color: ${COLORS.BgSurface};
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: ${BorderRadius.OuterBlockRadius};

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: none;
    }

    @media (max-width: 432px) {
        padding: 16px 20px;
    }

    ${({ styles }) => styles}
`;

export const Title = styled.p<{ styles?: TStyles }>`
    ${FONTS.H4};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.L};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
      ${FONTS.H5};
    }

    ${({ styles }) => styles}
`;

export const Content = styled.div<{ toggled?: boolean, styles?: TStyles }>`
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    // cubic-bezier instead of linear, so the animation will be smooth almost always
    transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
    padding-right: 12px;
    overflow: hidden;
    max-height: ${({ toggled }) => toggled ? '0px' : '1000px'};
    visibility: ${({ toggled }) => toggled ? 'hidden' : 'visible'};
    box-sizing: border-box;
    gap: 16px;
    grid-gap: 16px;

    ${({ styles }) => styles}
`;

export const ButtonToggle = styled(BaseButton)`
    height: 40px;
    width: 40px;
    & > div, & svg {
        height: 24px;
        width: 24px;
    }
`;

export const TitleRow = styled.div<{ toggled?: boolean }>`
    flex-direction: row;
    margin-bottom: ${({ toggled }) => toggled ? '0' : '12px'};
    justify-content: space-between;
    align-items: center;
`;
